/* Copyright */

export enum ResourceStatus {
  NONE,
  WARNING,
  ERROR,
  SERVICE,
}
